'use client'

import { getV3PoolBuckets } from '@sushiswap/graph-client/data-api'
import { keepPreviousData, useQuery } from '@tanstack/react-query'
import {
  type EvmAddress,
  type EvmChainId,
  SushiSwapProtocol,
  isSushiSwapV3ChainId,
} from 'sushi/evm'

interface UsePoolGraphDataParams {
  poolAddress: EvmAddress
  chainId: EvmChainId
  protocol: SushiSwapProtocol
  enabled?: boolean
}

const getPoolBuckets = async (
  protocol: SushiSwapProtocol,
  chainId: EvmChainId,
  poolAddress: EvmAddress,
) => {
  if (
    protocol === SushiSwapProtocol.SUSHISWAP_V3 &&
    isSushiSwapV3ChainId(chainId)
  ) {
    return getV3PoolBuckets({
      chainId,
      address: poolAddress,
    })
  }

  return {
    dayBuckets: [],
    hourBuckets: [],
  }
}

export const usePoolGraphData = ({
  poolAddress,
  chainId,
  protocol,
  enabled = true,
}: UsePoolGraphDataParams) => {
  return useQuery({
    queryKey: ['usePoolGraphData', { poolAddress, chainId }],
    queryFn: async () => {
      return getPoolBuckets(protocol, chainId, poolAddress)
    },
    placeholderData: keepPreviousData,
    staleTime: 0,
    gcTime: 3600, // 1hr
    enabled: Boolean(poolAddress && chainId && enabled),
  })
}
